import { cloneDeep } from 'lodash';
import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import JSZip from "jszip";
import { showToaster, toasterTypes } from '..';
import { MESSAGES } from '../../utils/Constants';

export default function FileUpload(props: any) {
    const [files, setfiles] = useState<any>([]);

    const onUpload = async (acceptedFiles: any) => {
        let allowedTypes = props.acceptFiles.split('|');

        // ---------------------- VALIDATION ----------------------
        for (let j = 0; j < acceptedFiles.length; j++) {
            const fileExt = acceptedFiles[j].name.split('.').pop()?.toLowerCase();

            if (!fileExt || !allowedTypes.includes(fileExt)) {
                let message = '';
                let fileTypes = allowedTypes;

                if (!props.messages?.acceptFiles && fileTypes.length > 1) {
                    for (let i = 0; i < fileTypes.length; i++) {
                        if (i === fileTypes.length - 1) message += " and " + fileTypes[i];
                        else if (i === 0) message = fileTypes[i];
                        else message += ", " + fileTypes[i];
                    }
                } else {
                    message = fileTypes[0];
                }

                showToaster(
                    toasterTypes.ERROR,
                    props.messages?.acceptFiles || MESSAGES.ALLOWED_TYPES.replace('#{value}', message)
                );
                return;
            }

            if (acceptedFiles[j].size > props.maxSize) {
                showToaster(
                    toasterTypes.ERROR,
                    props.messages?.maxSize || MESSAGES.MAX_SIZE.replace('#value', props.maxSize)
                );
                return;
            }
        }

        // ---------------------- TOTAL SIZE LIMIT ----------------------
        if (props.maxLimit) {
            const totalSize = acceptedFiles.reduce((sum, file) => sum + file.size, 0);
            if (totalSize > props.maxLimit) {
                const limitMB = (props.maxLimit / (1024 * 1024)).toFixed(2);
                showToaster(
                    toasterTypes.ERROR,
                    props.messages?.maxLimit || `Combined file size must not exceed ${limitMB} MB`
                );
                return;
            }
        }

        // ------------------------------------------
        //    CASE 1: isextract === true AND ZIP
        // ------------------------------------------
        if (
            props.isextract === true &&
            acceptedFiles.length === 1 &&
            acceptedFiles[0].name.toLowerCase().endsWith(".zip")
        ) {
            let extractedNames: string[] = [];

            try {
                const zip = await JSZip.loadAsync(acceptedFiles[0]);

                for (const fileName of Object.keys(zip.files)) {
                    const entry = zip.files[fileName];

                    if (entry.dir) continue;
                    if (fileName.startsWith("__MACOSX/")) continue;

                    const baseName = fileName.split("/").pop() || "";
                    if (baseName.startsWith("._")) continue;

                    extractedNames.push(baseName);
                }
            } catch (err) {
                console.error(err);
                showToaster(toasterTypes.ERROR, "Failed to extract zip file!");
                return;
            }

            // UI shows only the ZIP file
            setfiles([acceptedFiles[0]]);

            // Return original zip + extracted names
            props.onUpload({
                originalFile: acceptedFiles[0],
                extractedFiles: extractedNames
            });

            showToaster(toasterTypes.SUCCESS, "File Uploaded Successfully!");
            return;
        }

        // ------------------------------------------------------------
        // CASE 2: isextract === false  OR  file is NOT a zip
        // ----> KEEP OLD BEHAVIOR EXACTLY THE SAME
        // ------------------------------------------------------------
        setfiles(acceptedFiles);
        props.onUpload(acceptedFiles);

        showToaster(toasterTypes.SUCCESS, "File Uploaded Successfully!");
    };



    const deleteFile = (index: any, e: any) => {
        let temp = cloneDeep(files);
        temp.splice(index, 1);
        setfiles(temp);
        e.stopPropagation();
    };

    return (
        <div className='custom-file-upload'>
            <Dropzone onDrop={acceptedFiles => onUpload(acceptedFiles)} disabled={props.isDisabled}>
                {({ getRootProps, getInputProps }) => (
                    <section>
                        <div
                            {...getRootProps()}
                            className={`${(props.touched && props.error) ? 'error-field' : ''} upload-container`}
                        >
                            <input {...getInputProps()} />

                            {(files.length === 0 || props.value === "") ? (
                                <p>
                                    <span className='upload-placeholder'>{props.placeholder}</span>
                                    <u className='browse-text'>Browse Files</u>
                                </p>
                            ) : (
                                <div>
                                    {files.map((obj: any, index) => (
                                        <div key={index}>
                                            {obj.name}
                                            <img
                                                alt="close"
                                                src={`${process.env.PUBLIC_URL}/images/close_circle.svg`}
                                                onClick={(e) => deleteFile(index, e)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </section>
                )}
            </Dropzone>
        </div>
    );
}
